<template>
    <div class="public-offer-order-item">
        {{ offer.title }}
        <b>
            <template v-if="offer.is_free && showFreeTitle">
                <!--                - -->
                <!--                {{ t("payments.public-offer.free") }}-->
            </template>
            <template v-else-if="!offer.is_free">
                &nbsp;<s class="mr-5" v-if="offer.has_discount && offer.cost_info && !showPartialPrice">
                    {{ offer.cost_info.price.amount_formatted }}</s
                >
                <price-with-converted
                    class="amount-formatted"
                    v-if="order.price_info.price.amount"
                    :price="
                        showPartialPrice
                            ? paymentParts[0].price_info.price.amount_formatted
                            : order.price_info.price.amount_formatted
                    "
                    :show-converted="!!getVolatile(showPartialPrice ? paymentParts[0].price_info : order.price_info)"
                    :price-converted="getVolatile(showPartialPrice ? paymentParts[0].price_info : order.price_info)"
                    :default-currency="
                        showPartialPrice
                            ? paymentParts[0].price_info.price.currency.code
                            : order.price_info.price.currency.code
                    "
                    :absolute-converted-container="false"
                />
            </template>
        </b>
    </div>
</template>

<script>
import PriceWithConverted from "@components/PriceWithConverted.vue"

export default {
    components: { PriceWithConverted },
    props: {
        paymentParts: {
            type: Array,
            default: () => []
        },
        payment: {
            type: Object,
            default: null
        },
        showPartialPrice: {
            type: Boolean,
            default: false
        },
        offer: {
            type: Object,
            required: true,
            default: () => {}
        },
        order: {
            type: Object,
            required: true,
            default: () => {}
        },
        showFreeTitle: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferOrderItem",
    methods: {
        getVolatile(price_info) {
            return !price_info.price_converted.to_show ? "" : `${price_info.price_converted.amount_formatted}`
        }
    }
}
</script>

<style scoped lang="sass">
.amount-formatted
    display: inline-flex !important
.public-offer-order-item
    padding: 10px 0
    font-size: 14px
    font-family: Inter, sans-serif
    font-weight: 400
    line-height: 24px
    color: #52565C
    b
        font-weight: 700
        color: #52565C
    s
        color: #B5C1D2
        font-weight: 500
</style>
